import { gql } from '@apollo/client';

import {
  PAGE_INFO_FIELDS,
  RESUME_CARD_FIELDS,
  VACANCY_CARD_FIELDS
} from './fields';

export const GET_PROFILE_ADS = gql`
  ${VACANCY_CARD_FIELDS}

  ${RESUME_CARD_FIELDS}

  query Ads(
    $state: ProfileAdTabStatesEnum!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $adType: AdTypeEnum
  ) {
    profile {
      ... on UserProfile {
        ads(
          state: $state
          after: $after
          before: $before
          first: $first
          last: $last
          adType: $adType
        ) {
          nodes {
            ... on Resume {
              ...resumeCardFields
            }
            ... on Vacancy {
              ...vacancyCardFields
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
    }
  }
`;

export const GET_VACANCIES = gql`
  ${VACANCY_CARD_FIELDS}

  ${PAGE_INFO_FIELDS}

  query Vacancies(
    $filter: AdFilter
    $scope: AdScopeEnum
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: AdSortByEnum
  ) {
    vacancies(
      filter: $filter
      scope: $scope
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
    ) {
      totalCount
      edges {
        cursor
      }
      nodes {
        ...vacancyCardFields
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;

export const GET_RESUMES = gql`
  ${RESUME_CARD_FIELDS}
  ${PAGE_INFO_FIELDS}

  query Resumes(
    $filter: AdFilter
    $scope: AdScopeEnum
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: AdSortByEnum
  ) {
    resumes(
      filter: $filter
      scope: $scope
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
    ) {
      totalCount
      edges {
        cursor
        node {
          ...resumeCardFields
        }
      }
      nodes {
        ...resumeCardFields
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;
